// Copied templates must not share block ids with their source: the block id
// is the basis of the inline editor's DOM id and is used as the v-for key,
// and all template editors of an event are mounted at the same time.
export const withFreshBlockIds = (blocks: any[]) =>
  (blocks || []).map((block) => ({
    ...JSON.parse(JSON.stringify(block)),
    id: Date.now() + '_' + Math.random().toString(36).substr(2, 9),
  }));
